import {setupWorker} from "msw";

/**
 * Starts the MSW service worker in development mode, only when
 * `./__mocks/handlers` exports a non-empty `mockServiceWorkerHandlers` list.
 * Add handlers there to intercept the running app; leave it empty to hit live APIs.
 */
export const startMockServiceWorker = async () => {
    if (process.env.NODE_ENV !== "development") {
        return Promise.resolve();
    }

    // First, unregister any existing service workers to prevent conflicts
    if ("serviceWorker" in navigator) {
        console.log("unregistering existing service workers");
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
                // Only unregister MSW service workers
                if (registration.scope.includes("/static-km/") || registration.active?.scriptURL.includes("mockServiceWorker")) {
                    registration.unregister().catch((error) => {
                        console.warn("Failed to unregister existing service worker:", error);
                    });
                }
            }
        });
    }

    // Only start MSW if there are handlers to avoid unnecessary service worker registration
    const {mockServiceWorkerHandlers} = await import("./__mocks/handlers");

    if (mockServiceWorkerHandlers.length > 0) {
        const kmMockServiceWorker = setupWorker(...mockServiceWorkerHandlers);

        kmMockServiceWorker
            .start({
                serviceWorker: {
                    url: "/mockServiceWorker.js"
                },
                onUnhandledRequest: "bypass"
            })
            .catch((error) => {
                console.error("Failed to start MSW:", error);
            });
    }

    return Promise.resolve();
};
import {setupWorker} from "msw";

/**
 * Starts the MSW service worker in development mode, only when
 * `./__mocks/handlers` exports a non-empty `mockServiceWorkerHandlers` list.
 * Add handlers there to intercept the running app; leave it empty to hit live APIs.
 */
export const startMockServiceWorker = async () => {
    if (process.env.NODE_ENV !== "development") {
        return Promise.resolve();
    }

    // First, unregister any existing service workers to prevent conflicts
    if ("serviceWorker" in navigator) {
        console.log("unregistering existing service workers");
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
                // Only unregister MSW service workers
                if (registration.scope.includes("/static-km/") || registration.active?.scriptURL.includes("mockServiceWorker")) {
                    registration.unregister().catch((error) => {
                        console.warn("Failed to unregister existing service worker:", error);
                    });
                }
            }
        });
    }

    // Only start MSW if there are handlers to avoid unnecessary service worker registration
    const {mockServiceWorkerHandlers} = await import("./__mocks/handlers");

    if (mockServiceWorkerHandlers.length > 0) {
        const kmMockServiceWorker = setupWorker(...mockServiceWorkerHandlers);

        kmMockServiceWorker
            .start({
                serviceWorker: {
                    url: "/mockServiceWorker.js"
                },
                onUnhandledRequest: "bypass"
            })
            .catch((error) => {
                console.error("Failed to start MSW:", error);
            });
    }

    return Promise.resolve();
};
